export default {
  links: {
    terms: 'Obchodní podmínky',
    privacy: 'GDPR',
    about: 'O nás',
    contacts: 'Kontakty',
  },
};
